// removed by extract-text-webpack-plugin
module.exports = {"popover":"src-components-modules-FormWrap-FormSelect-style----general-module---popover---3AdcZ fontSize-s fontWeight-5 lineHeight-s paddingLeftRight-xs textAlign-center truncateText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/FormWrap/FormSelect/style/general.module.css
// module id = 1455
// module chunks = 168707334958949